<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vi"></a><a id="page_vii"></a>CONTENTS</h2>
<p class="toc"><span href="#/html/cover" title="Link target outside of Sample"><span class="small">COVER</span></span></p>
<p class="toc"><span href="#/html/9780292735453_03_cpy" title="Link target outside of Sample"><span class="small">COPYRIGHT</span></span></p>
<p class="toc"><a href="#/html/9780292735453_06_ack#ack"><span class="small">ACKNOWLEDGMENTS</span></a></p>
<p class="toct"><a href="#/html/9780292735453_08_int#int">Introduction</a></p>
<p class="toc-chap"><a href="#/html/9780292735453_09_ch1#ch1"><span class="small">CHAPTER</span> 1.   Color Them Black</a></p>
<p class="toc-chap"><span href="#/html/9780292735453_10_ch2#ch2" title="Link target outside of Sample"><span class="small">CHAPTER</span> 2.   Birth of the Cool</span></p>
<p class="toc-chap"><span href="#/html/9780292735453_11_ch3#ch3" title="Link target outside of Sample"><span class="small">CHAPTER</span> 3.   Friends and Lovers</span></p>
<p class="toc-chap"><span href="#/html/9780292735453_12_ch4#ch4" title="Link target outside of Sample"><span class="small">CHAPTER</span> 4.   Attack of the Clones</span></p>
<p class="toc-chap"><span href="#/html/9780292735453_13_ch5#ch5" title="Link target outside of Sample"><span class="small">CHAPTER</span> 5.   For Reel? <em>Black Superheroes Come to Life</em></span></p>
<p class="toct"><span href="#/html/9780292735453_14_not#not" title="Link target outside of Sample"><span class="small">NOTES</span></span></p>
<p class="toc"><span href="#/html/9780292735453_15_bib#bib" title="Link target outside of Sample"><span class="small">BIBLIOGRAPHY</span></span></p>
<p class="toc"><span href="#/html/9780292735453_16_ind#ind" title="Link target outside of Sample"><span class="small">INDEX</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292735453_05_toc.vue?0f562f98